// removed by extract-text-webpack-plugin
module.exports = {"fullScreenSection":"src-components-FullScreenSection----FullScreenSection-module---fullScreenSection---3MOzW","fullScreenSectionInner":"src-components-FullScreenSection----FullScreenSection-module---fullScreenSectionInner---gDGj4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FullScreenSection/FullScreenSection.module.scss
// module id = 106
// module chunks = 178469467687848 221374088121123